import { Flex, FormDateInput, Grid, Text, Box } from '@shared/components';

export default function ItemAnalysisDateFilterFormField() {
  return (
    <Grid
      sx={(theme) => ({
        columnGap: theme.spacing(6),
        rowGap: theme.spacing(6),
        gridTemplateColumns: '160px 1fr',
      })}
    >
      <Text variant='body1Semibold'>Date Filter:</Text>
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(1),
          flex: 1,
          alignItems: 'flex-start',
        })}
      >
        <Box sx={{ width: '256px' }}>
          <FormDateInput
            name='startDate'
            label='Start Date'
            inputFormat='DD MMM BBBB'
            labelFormat='MMMM BBBB'
            placeholder='DD-MM-YYYY'
            yearLabelFormat='BBBB'
          />
        </Box>
        <Box sx={{ whiteSpace: 'nowrap', p: (theme) => theme.spacing(8.5, 1, 2.5, 1) }}>to</Box>
        <Box sx={{ width: '256px' }}>
          <FormDateInput
            name='endDate'
            label='End Date'
            inputFormat='DD MMM BBBB'
            labelFormat='MMMM BBBB'
            placeholder='DD-MM-YYYY'
            yearLabelFormat='BBBB'
          />
        </Box>
      </Flex>
    </Grid>
  );
}
